/*
 * Nhóm ngành hàng
 */
export const ORDER_GROUP_USING = 'ORDER_GROUP:USING'; // Xem sửa thông tin nhóm ngành hàng
export const UPDATE_LOGO = 'SYSTEM:UPDATE_LOGO'; // Logo

/*
   * Quyền cấu hình hệ thống
 */
export const SETTING_GENERAL = 'SETTING:GENERAL';